/** @format */

const ConfirmHealthLetter = () =>
  import("../../../../pages/HQ/myHealthLetters/confirmHealthLetter.vue");

const ViewHealthLetter = () =>
  import("../../../../pages/HQ/myHealthLetters/viewHealthLetterRequest.vue");

const HealthLettersDash = () =>
  import("../../../../pages/HQ/myHealthLetters/myHealthLettersDash.vue");
const AddViewDoctor = () =>
  import("../../../../pages/HQ/myHealthLetters/addViewDoctor.vue");

const myHealthLettersRoutesHq = [
  {
    path: "",
    name: "hq-HealthLettersDashboard",
    component: HealthLettersDash,
  },
  {
    path: "/view-letter/:letterId",
    name: "viewHealthLetterHq",
    component: ViewHealthLetter,
  },
  {
    path: "/:isMo/confirm-letter/:letterId",
    name: "confirmHealthLetter",
    component: ConfirmHealthLetter,
  },
  {
    path: "/view-doctor/:doctorId/:isView",
    name: "viewDoctorHq",
    component: AddViewDoctor,
  },
];

export default myHealthLettersRoutesHq;
